export const formDefaultValues = {
  dni: '',
  lastname: '',
  firstname: '',
  mobile: '',
  country: '',
  gender: 'female',
  birth: '',
}
